import listQuery from '../../queries/purchases/PurchaseOrderListQuery.graphql';
import instanceQuery from '../../queries/purchases/PurchaseOrderAssignmentQuery.graphql';
import mutationQuery from '../../mutations/purchases/PurchaseOrderAssignmentsMutation.graphql';
import aggregateQuery from '../../queries/purchases/PurchaseOrderAggregateQuery.graphql';
import fragment from '../../fragments/purchases/PurchaseOrderAssignmentFragment.graphql';
import { EntityType } from '../../../@types/entityTypes';

const PurchaseOrderAssignment: EntityType = {
  type: 'PurchaseOrder',
  title: 'Purchase Order Assignments',
  formUrl: '/Purchasing/Assignment/Details/',
  formTitle: 'Purchase Order Assignments',
  workspaceUrl: '/Purchasing/Order/Workspace/',
  instance: instanceQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'orderNumber',
  },
  aggregate: aggregateQuery,
  fragment,
  screenReference: 'PURCHASE_ASSIGNMENT',
  permissionLabel: 'Assign to Sales',
};

export default PurchaseOrderAssignment;
